import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { FuseValidators } from '@fuse/validators';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ChangePasswordComponent implements OnInit {

  passwordForm: FormGroup;

  erroPasswordActual: boolean = false;
  updatingPassword: boolean = false;


  constructor(
    public dialogRef: MatDialogRef<ChangePasswordComponent>,
    private formBuilder: FormBuilder
  ) { 
    this.passwordForm = this.createPasswordForm();
  }

  ngOnInit(): void {

  }

  createPasswordForm(): FormGroup {
    return this.formBuilder.group({
      password: ['', [Validators.required ]],
      newPassword: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(15)]],
      passwordConfirm: ['', [Validators.required ]],
  },
  {
      validators: FuseValidators.mustMatch('newPassword', 'passwordConfirm')
  });
  }


  updatePassword(): void {
    
  }
  
  cancelUpdate(): void {    
    this.dialogRef.close(null);
  }

}
